import { useContext } from 'react';
import { fuzzySearchIndexerContext } from './context';

export const useFuzzySearchIndexerRef = () => {
  const fuzzySearchIndexerRef = useContext(fuzzySearchIndexerContext);
  return fuzzySearchIndexerRef;
};
